import { Stack } from "@mui/material";
import { Headings } from "./Headings/0_headingsTree";
import { ModalData, PropertyModal } from "../PropertyModal/PropertyModal";
import { useRef, useState } from "react";
import { ChartMode } from "../Chart/chart.types";
import { Lca } from "./Lca/0_lcaTree";

// It is supposed to be a DIMENSIONS TREE.
// There may be an infinite tree at some point.
const allowedDimensions: Record<string, string[]> = {
    heading: ["headings", "subheadings", "properties", "subproperties", "multivalues"],
    lca: ["lca"],
    component: ["company"],
} as const;

type DimensionTreeSwitchProps = {
    mode: ChartMode;
};
export const DimensionTreeSwitch = (props: DimensionTreeSwitchProps) => {
    const { mode } = props;

    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const propertyRef = useRef<ModalData | null>(null);

    const openModal = (property: ModalData) => {
        propertyRef.current = property;
        setModalOpen(true);
    };

    const isHeadingTree = true;
    const isLca = false;

    return (
        <Stack>
            <PropertyModal isOpen={isModalOpen} setOpen={setModalOpen} property={propertyRef.current} />

            {/* Depending on the current tree used... */}
            {isHeadingTree && <Headings openModal={openModal} mode={mode} />}
            {isLca && <Lca mode={mode} />}
        </Stack>
    );
};
